/**
 * Attach the bearer token to a GLTF loader so `/v1/models/...` GLBs pass the secured
 * gateway (ADR 112) — `useGLTF` / `useGLTF.preload` fetch the URL directly and would
 * otherwise 403. Harmless for bundled `/models/...` assets: the static host ignores the
 * header. Pass as the `extendLoader` (4th) argument of `useGLTF` and `preload`.
 *
 * The token is published on `window` by the site store (mirrors rest.ts's authHeaders).
 * At module-load time (the bundled-model preloads) it isn't set yet — fine, those assets
 * are public; the server-scoped loads happen after login when the token is present.
 */
export function gltfWithAuth(loader: { setRequestHeader?: (headers: Record<string, string>) => void }): void {
  const token = (globalThis as { __SITE_STORE_TOKEN?: string }).__SITE_STORE_TOKEN;
  if (token && loader.setRequestHeader) {
    loader.setRequestHeader({ Authorization: `Bearer ${token}` });
  }
}
